import { Transform } from 'class-transformer';
import { IsString, IsNotEmpty, IsMimeType, IsIn } from 'class-validator';
import sanitize from 'sanitize-filename';
import { ImageDestinationArray, ImageDestinationEnum } from '../../enums';

export class CreateImageDto {
	@Transform(({ value }) => (typeof value === 'string' ? sanitize(value) : null))
	@IsNotEmpty()
	@IsString()
	name: string;

	@IsMimeType() mimeType: string;

	@IsIn(ImageDestinationArray) destination: ImageDestinationEnum;
}
